<template>
  <div class="asf-admin-login container py-4 px-8">
    <div class="login-card card p-4 mb-4 mx-auto" style="max-width: 500px;">
        <img src="../../assets/logo-blanco.png" alt="Logo Agile Sin Filtros" class="login-logo mb-4">
        <h2 class="login-title text-center mb-4">Acceso al Panel de Administración ASF</h2>
        <div v-show="authError" class="error-message alert alert-danger" style="min-height: 50px;">{{ authError }}</div>
        
        <div id="g_id_onload"
             data-client_id="622311184713-disg3apn4qclkj65fusva3oa7fhtvdsj.apps.googleusercontent.com"
             data-callback="handleCredentialResponse"
             data-auto_prompt="false">
        </div>

        <div class="g_id_signin"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { BAlert } from 'bootstrap-vue-next'; // BButton y BSpinner ya no son necesarios

const authError = ref(null);
const router = useRouter();

// Función para manejar la respuesta de Google Sign-In
const handleCredentialResponse = async (response) => {
    if (response.credential) {
        try {
            // Enviar el token de ID a tu backend PHP
            const backendResponse = await fetch('https://sokar.es/api/auth.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id_token: response.credential })
            });

            const data = await backendResponse.json();

            if (backendResponse.ok && data.token) {
                if (data.user.role === 'usuario') {
                    authError.value = data.message; // Mostrar el mensaje de registro
                    setTimeout(() => { authError.value = null; }, 10000); // Mostrar por más tiempo
                } else {
                    // Almacenar el token JWT y la información del usuario
                    localStorage.setItem('jwt_token', data.token);
                    localStorage.setItem('user_role', data.user.role); // Almacenar el rol del usuario
                    localStorage.setItem('user_name', data.user.name); // Almacenar el nombre del usuario
                    localStorage.setItem('user_email', data.user.email); // Almacenar el email del usuario

                    // Redirigir al dashboard principal
                    router.push({ name: 'ASFAdminDashboard' });
                }
            } else {
                authError.value = data.message || "Error de autenticación con el servidor.";
                setTimeout(() => { authError.value = null; }, 5000);
            }
        } catch (error) {
            console.error("Error al comunicarse con el backend:", error);
            authError.value = "Error de red o del servidor. Inténtalo de nuevo.";
            setTimeout(() => { authError.value = null; }, 5000);
        }
    }
};

onMounted(() => {
    // Asegurarse de que la función handleCredentialResponse esté disponible globalmente
    // para el script de Google GSI.
    window.handleCredentialResponse = handleCredentialResponse;

    // Inicializar Google Sign-In y renderizar el botón
    if (window.google) {
        const CLIENT_ID = "622311184713-disg3apn4qclkj65fusva3oa7fhtvdsj.apps.googleusercontent.com";
        window.google.accounts.id.initialize({
            client_id: CLIENT_ID,
            callback: handleCredentialResponse,
            auto_prompt: false
        });
        window.google.accounts.id.renderButton(
            document.querySelector(".g_id_signin"),
            { type: "standard", shape: "rectangular", theme: "dark", text: "signin_with", size: "large", logo_alignment: "left" } // customization attributes
        );
    } else {
        console.error("La librería de Google GSI no está cargada. Asegúrate de que el script se haya cargado correctamente en index.html.");
    }
});
</script>

<style scoped>
.asf-admin-login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh; /* Centra verticalmente en la vista */
}
.login-card {
    background-color: rgb(106, 36, 129); /* Morado de la cabecera */
    border: none; /* Eliminar borde */
    border-radius: 15px; /* Bordes más redondeados */
    box-shadow: 0 10px 25px rgba(0,0,0,.2); /* Sombra más pronunciada y suave */
    padding: 40px !important; /* Aumentar padding */
}
.error-message {
    background-color: #dc3545; /* Rojo oscuro para el fondo */
    color: #ffffff !important; /* Texto blanco para alto contraste */
    border-color: #dc3545; /* Borde del mismo color que el fondo */
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
    padding: 15px; /* Más padding para mejor lectura */
    border-radius: 8px; /* Bordes ligeramente redondeados */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra sutil */
}
.g_id_signin {
    margin-top: 20px; /* Espacio entre el título y el botón de Google */
    display: flex;
    justify-content: center;
}
.login-logo {
    display: block;
    margin: 0 auto;
    max-width: 150px; /* Ajusta el tamaño del logo */
    height: auto;
}

.login-title {
    color: #ffffff; /* Texto blanco para contraste */
    font-weight: 600; /* Más negrita */
    font-size: 1.8rem; /* Tamaño de fuente más grande */
}
</style>